import { atomWithQuery } from 'jotai-tanstack-query';
import { instance } from '..';
import { DefaultOption, PlanCar, PlanDest } from '@/types/plan';
import { AxiosError } from 'axios';

export const defaultOptionAtom = atomWithQuery<DefaultOption, AxiosError, any, [string]>((get) => ({
  queryKey: ['DEFAULT_OPTION'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await getDefaultOption();
    if (temp && temp.data) {
      return temp.data.data;
    }
  },
}));

const getDefaultOption = async () => {
  return await instance.get('/api_shipping_v2/site_option', null);
};

export const getCoordInfo = async (targetList: PlanDest[]) => {
  return await instance.post('/api_shipping_v2/getCoorInfo', { targetList });
};

export const getGeoInfo = async (address: string) => {
  return await instance.get('/api_shipping_v2/getGeoInfo', { params: { address } });
};

export const postCoordInfo = async (target: any) => {
  return await instance.post('/api_shipping_v2/postCoordInfo', target);
};

export const putCoordInfo = async (target: PlanDest) => {
  return await instance.put('/api_shipping_v2/putCoordInfo', target);
};
export const putDestInfoList = async (target: any) => {
  return await instance.put('/api_shipping_v2/putDestInfo', target);
};

export const putCoordsRegion = async () => {
  return await instance.put('/api_shipping_v2/manage/coords/region', null);
};

export const getDuplicateCoords = async () => {
  return await instance.get('/api_shipping_v2/manage/coords/duplicates');
};

export const deleteDuplicateCoords = async () => {
  return await instance.delete('/api_shipping_v2/manage/coords/duplicates');
};

export const planCarListAtom = atomWithQuery<PlanCar[], AxiosError, any, [string]>(() => ({
  queryKey: ['PLAN_CAR_LIST'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await getCarList();
    if (temp && temp.data) {
      return temp.data.data;
    }
  },
}));

export const putCars = async (target: any) => {
  return await instance.put('/api_shipping_v2/cars', target);
};

export const getCarList = async () => {
  return await instance.get('/api_shipping_v2/cars', null);
};

export const masterDestListAtom = atomWithQuery<any[], AxiosError, any, [string]>(() => ({
  queryKey: ['MASTER_DEST_LIST'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await getDests();
    if (temp && temp.data) {
      return temp.data.data;
    }
  },
}));

const getDests = async () => {
  return await instance.get('/api_shipping_v2/manage/dests', null);
};

export const centerListAtom = atomWithQuery<any, AxiosError, any, [string]>(() => ({
  queryKey: ['CENTER_LIST'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await getCoords('CENTER');
    if (temp && temp.data) {
      return temp.data.data;
    }
  },
}));

export const cargoListAtom = atomWithQuery<any, AxiosError, any, [string]>(() => ({
  queryKey: ['CARGO_LIST'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await getCoords('CARGO');
    if (temp && temp.data) {
      return temp.data.data;
    }
  },
}));

const getCoords = async (type: string) => {
  return await instance.get('/api_shipping_v2/coords', { params: { type } });
};
